var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6068 8.02368H3.10837C2.40748 8.02368 1.83929 8.59187 1.83929 9.29276V30.7095C1.83929 31.4103 2.40748 31.9785 3.10837 31.9785H32.6068C33.3077 31.9785 33.8759 31.4103 33.8759 30.7095V9.29276C33.8759 8.59187 33.3077 8.02368 32.6068 8.02368Z",
    fill: "#4989F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2366 7.84372H3.44318C2.55125 7.84372 1.85718 14.7466 1.85718 15.6385L17.6253 31.9785H32.2366C33.1312 31.9761 33.8559 31.2514 33.8583 30.3568V9.46516C33.8557 8.57062 33.1311 7.84616 32.2366 7.84372V7.84372Z",
    fill: "url(#paint0_linear_122_55)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15436 12.0353H18.3077V0.021759H10.5249L9.15436 12.0353Z",
    fill: "#3C4BA6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.461 12.0353H18.3077V0.021759H26.0904L27.461 12.0353ZM33.8759 2.29908L33.8872 2.34003C33.8845 2.32557 33.879 2.31215 33.8759 2.29908Z",
    fill: "#7BABF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8872 2.33969L33.8759 2.29874C33.5857 0.969893 32.4095 0.0222836 31.0494 0.0214233H26.0904L27.4599 12.0353H36.6133L33.8872 2.33969Z",
    fill: "#3F51B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73944 2.29907L2.72809 2.34002C2.73084 2.32557 2.73635 2.31215 2.73944 2.29907Z",
    fill: "#7BABF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72776 2.33969L2.73911 2.29874C3.0293 0.969893 4.20547 0.0222836 5.56563 0.0214233H10.5249L9.15332 12.0353H0L2.72776 2.33969Z",
    fill: "#7BABF7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16982 12.0322C9.16982 14.5584 7.12192 16.6063 4.59575 16.6063C2.06957 16.6063 0.0216675 14.5584 0.0216675 12.0322H9.16982Z",
    fill: "#709BE0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.318 12.0322C18.318 14.5584 16.2701 16.6063 13.7439 16.6063C11.2178 16.6063 9.16986 14.5584 9.16986 12.0322H18.318Z",
    fill: "#3C4BA6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4661 12.0322C27.4661 14.5584 25.4182 16.6063 22.8921 16.6063C20.3659 16.6063 18.318 14.5584 18.318 12.0322H27.4661Z",
    fill: "#709BE0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6132 12.0322C36.6132 14.5584 34.5653 16.6063 32.0392 16.6063C29.513 16.6063 27.4651 14.5584 27.4651 12.0322H36.6132Z",
    fill: "#3C4BA6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0394 24.4247C32.0232 24.2068 31.9963 24.0079 31.9581 23.754H26.9686C26.9686 24.4518 26.9686 25.2134 26.9658 25.9116H29.8563C29.7949 26.2369 29.6698 26.547 29.4882 26.8239C29.3067 27.1008 29.0721 27.3391 28.7982 27.5251C28.7982 27.5251 28.7982 27.513 28.7961 27.5127C28.4423 27.745 28.0438 27.9006 27.6262 27.9693C27.2075 28.0459 26.7782 28.0441 26.3602 27.9638C25.9357 27.876 25.5338 27.7018 25.1795 27.4521C24.6565 27.0813 24.2532 26.5658 24.0188 25.969C24.001 25.9226 23.9844 25.8758 23.9676 25.8283V25.8231L23.972 25.8197C23.7446 25.1522 23.744 24.4284 23.9703 23.7605C24.1297 23.292 24.392 22.8652 24.738 22.5114C25.5497 21.6718 26.7624 21.356 27.8804 21.6931C28.3092 21.8246 28.7009 22.0552 29.0239 22.3662L29.9991 21.391C30.1712 21.2172 30.3498 21.0489 30.5153 20.8693C30.0208 20.4081 29.4404 20.0487 28.8071 19.8115C27.6546 19.3936 26.3939 19.3826 25.2342 19.7802C25.1939 19.794 25.1537 19.8083 25.1138 19.8232C23.8627 20.2935 22.8335 21.2159 22.2295 22.4082C22.0162 22.8302 21.8608 23.2791 21.7677 23.7426C21.2153 26.4877 22.8903 29.1897 25.5945 29.916C26.4785 30.1527 27.4183 30.1469 28.3092 29.9445C29.1187 29.7618 29.8671 29.3728 30.4819 28.8155C31.1233 28.2253 31.5831 27.4391 31.8239 26.6039C32.0253 25.8962 32.0983 25.1581 32.0394 24.4247Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_122_55",
    x1: 1.85718,
    y1: 19.9109,
    x2: 33.858,
    y2: 19.9109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4079D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4989F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmb);
export default __webpack_public_path__ + "static/media/GMB.3b2dfd90f0a6b6ce001598c1de445aa7.svg";
export { ForwardRef as ReactComponent };